<template>
  <v-card class="dash-section" elevation="0">
    <div class="dash-section-header">
      <div class="dash-section-badge">
        <v-icon color="white">mdi-garage</v-icon>
      </div>
      <h2 class="dash-section-title">Garage Updates</h2>
    </div>

    <div class="dash-grid">
      <summary-card
        v-for="(item, index) in summaries"
        :key="index"
        :count="item.count"
        :title="item.title"
        :category="item.category"
        :icon="item.icon"
        :loading="isLoading"
      ></summary-card>
    </div>

    <v-divider class="dash-divider"></v-divider>
    <div class="dash-updated">
      <v-icon color="primary" size="18">mdi-clock-time-four</v-icon>
      <span>Just Updated</span>
    </div>
  </v-card>
</template>

<script>
export default {
  components: {
    SummaryCard: () => import('@/components/dashboard/SummaryCard'),
  },
  props: {
    summary: {
      type: Object,
      default: () => ({
        total_vehicles: 0,
        repairs_count: 0,
        released_count: 0,
      }),
    },
    isLoading: { type: Boolean, required: true },
  },
  computed: {
    summaries() {
      return [
        {
          count: this.summary.total_vehicles,
          title: 'No. of vehicles in garages',
          category: 'ALL',
          icon: 'mdi-garage',
        },
        {
          count: this.summary.repairs_count,
          title: 'No. of Repairs in Progress',
          category: 'REPAIR_IN_PROGRESS',
          icon: 'mdi-wrench',
        },
        {
          count: this.summary.released_count,
          title: 'No. of Released vehicles',
          category: 'VEHICLE_RELEASED',
          icon: 'mdi-car-arrow-right',
        },
      ]
    },
  },
}
</script>

<style scoped>
.dash-section {
  border-radius: 18px;
  border: 1px solid #e8edf5;
  background: #ffffff;
  padding: 18px 20px;
}
.dash-section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.dash-section-badge {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #034ea2 0%, #0a63c4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(3, 78, 162, 0.25);
}
.dash-section-title {
  font-size: 20px;
  font-weight: 800;
  color: #0f2a55;
  margin: 0;
}
.dash-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}
@media (min-width: 600px) {
  .dash-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 960px) {
  .dash-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
.dash-divider {
  margin: 16px 0 0;
}
.dash-updated {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-top: 10px;
  font-size: 13px;
  color: #6b7684;
}
</style>
